import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA service worker (best-effort; ignored on unsupported browsers).
// When the SW installs a fresh version it broadcasts { type: 'sw-updated' } and
// we reload the page so returning users pick up the new bundle immediately.
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((err) => console.warn('SW registration failed:', err));
  });
  navigator.serviceWorker?.addEventListener?.('message', (event) => {
    if (event.data?.type === 'sw-updated') {
      // Only reload if there IS a controller (otherwise this is a first install)
      if (navigator.serviceWorker.controller) {
        // Debounce so multiple messages don't cause a reload storm
        if (!window.__selahReloading) {
          window.__selahReloading = true;
          window.location.reload();
        }
      }
    }
  });
}
